import * as Yup from "yup";
import "yup-phone";

const alphabetsRegEx = /^[a-zA-Z ]+$/
const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/
// const noSpecialCharRegEx = /^[^*|\":<>[\]{}`\\()';@&$]+$/;
// const restrictedDomainRegEx = /^((?!(yahoo|gmail)).)*$/;

Yup.addMethod(Yup.string, 'isRestrictedDomain', function (args) {
    const message = args || 'Please use the work email to sign up.';
    // console.info({args});
    return this.test('isRestrictedDomain', message, function (value) {
        // console.info({value});
        if (!value) return false;
        // console.info({message});
        const { path, createError } = this;
        // const { some, more, args } = args;
        // [value] - value of the property being tested
        // [path]  - property name,
        // ...
        const restrictedDomains = ['gmail.com', 'hotmail.com', 'yahoo.com'];
        const matchedDomain = restrictedDomains.filter(domainName => {
            return value.trim().toLowerCase().includes(domainName.trim().toLowerCase());
        });
        return matchedDomain.length <= 0 || createError({ path, message: message });
    });
});

export const addSingleEmployeeFormValidationSchema = Yup.object({
    newEmployeeFirstName: Yup.string().matches(alphabetsRegEx, 'Only alphabets are allowed.').required('Please provide first name.').min(2, 'Must be 2 characters long').max(30, 'Max 30 characters allowed.'),
    newEmployeeLastName: Yup.string().matches(alphabetsRegEx, 'Only alphabets are allowed.').required('Please provide last name.').min(2, 'Must be 2 characters long').max(30, 'Max 30 characters allowed.'),
    // newEmployeeContactNumber: Yup.string().phone("US", false, 'Please provide a valid US region number.').required('Please provide contact number.'),
    newEmployeeContactNumber: Yup.string().matches(phoneRegExp, 'Phone number is not valid'),
    newEmployeeEmail: Yup.string().email('Please provide a valid email address.').required('Please provide email address.').isRestrictedDomain(),
});

export const singleTeamFormValidationSchema = Yup.object({
    teamName: Yup.string().matches(alphabetsRegEx, 'Only alphabets are allowed.').required('Team name is required.').min(2, 'Minimum 2 characters long').max(15, 'Max 15 characters long.'),
    teamBudget: Yup.number().required('Team budget is required.').positive('Positive numbers only.').min(1, 'Minimum value is 1').max(9999, 'Max value is 9999'),
    teamExpenseLimit: Yup.number().required('Expense limit is required.').positive('Positive numbers only.').min(0, 'Minimum value is 1').max(20000, 'Max value is 20000'),
});

export const FreeTrialSingleTeamFormValidationSchema = Yup.object({
    teamName: Yup.string().matches(alphabetsRegEx, 'Only alphabets are allowed.').required('Team name is required.').min(2, 'Minimum 2 characters long').max(15, 'Max 15 characters long.'),
    teamBudget: Yup.number().required('Team budget is required.').positive('Positive numbers only.').min(1, 'Minimum value is 1').max(9999, 'Max value is 9999'),
    teamExpenseLimit: Yup.number().required('Expense limit is required.').positive('Positive numbers only.').min(0, 'Minimum value is 1').max(300, 'Max value is 300'),
});


export const newTeamFormValidationSchema = Yup.object({
    newTeamName: Yup.string().matches(alphabetsRegEx, 'Only alphabets are allowed.').required('Team name is required.').min(2, 'Minimum 2 characters long').max(15, 'Max 15 characters long.'),
    newTeamBudget: Yup.number().required('Team budget is required.').positive('Positive numbers only.').min(1, 'Minimum value is 1').max(9999, 'Max value is 9999'),
    newTeamExpenseLimit: Yup.number().required('Expense limit is required.').positive('Positive numbers only.').min(0, 'Minimum value is 1').max(20000, 'Max value is 20000'),
});

export const FreeTrialNewTeamFormValidationSchema = Yup.object({
    newTeamName: Yup.string().matches(alphabetsRegEx, 'Only alphabets are allowed.').required('Team name is required.').min(2, 'Minimum 2 characters long').max(15, 'Max 15 characters long.'),
    newTeamBudget: Yup.number().required('Team budget is required.').positive('Positive numbers only.').min(1, 'Minimum value is 1').max(9999, 'Max value is 9999'),
    newTeamExpenseLimit: Yup.number().required('Expense limit is required.').positive('Positive numbers only.').min(0, 'Minimum value is 1').max(300, 'Max value is 300'),
});

export const perkPriceLimitFormValidationSchema = Yup.object({
    perkPriceLimit: Yup.number().required('Limit is required.').positive('Positive numbers only.').min(1, 'Minimum value is 1').max(1000, 'Max value is 1000'),
});
